import { useMutation, useQuery } from "@tanstack/react-query";
import instance from "services/axiosServices";
import leadsWebEnviroment from "utils/leadsWebEnviroment";

export function useSalvarNoOutlookPreferencia() {
  return useQuery({
    queryKey: ["salvar-no-outlook-preferencia"],
    queryFn: async () => {
      const response = await instance.get(
        `${leadsWebEnviroment}/commom/leads/preferencias-carteira/v1`
      );
      return (response?.data?.data?.salvarNoOutlook as boolean) ?? false;
    },
    refetchOnWindowFocus: false,
  });
}

export function useSalvarNoOutlookMutation() {
  return useMutation({
    mutationFn: async (salvarNoOutlook: boolean) => {
      await instance.put(
        `${leadsWebEnviroment}/commom/leads/salvar-no-outlook/v1`,
        { salvarNoOutlook }
      );
    },
  });
}
